"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.withMuiPickersUtilsProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/fr");

var _materialUiPickers = require("material-ui-pickers");

var _moment2 = _interopRequireDefault(require("@date-io/moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

_moment.default.locale('fr');

var LocalizedUtils =
/*#__PURE__*/
function (_MomentUtils) {
  _inherits(LocalizedUtils, _MomentUtils);

  function LocalizedUtils() {
    _classCallCheck(this, LocalizedUtils);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalizedUtils).apply(this, arguments));
  }

  _createClass(LocalizedUtils, [{
    key: "getDatePickerHeaderText",
    value: function getDatePickerHeaderText(date) {
      return (0, _moment.default)(date).format('DD MMM YYYY', {
        locale: this.locale
      });
    }
  }]);

  return LocalizedUtils;
}(_moment2.default);

var withMuiPickersUtilsProvider = function withMuiPickersUtilsProvider(WrappedComponent) {
  return function (props) {
    return _react.default.createElement(_materialUiPickers.MuiPickersUtilsProvider, {
      utils: LocalizedUtils,
      moment: _moment.default,
      locale: "fr"
    }, _react.default.createElement(WrappedComponent, props));
  };
};

exports.withMuiPickersUtilsProvider = withMuiPickersUtilsProvider;
var _default = withMuiPickersUtilsProvider;
exports.default = _default;